<template>
  <v-footer app color="#f5f5f5" class="app-footer" elevation="4">
    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12" class="text-center">
          <div class="footer-content">
            <!-- Visitor Counter - Hidden on mobile (< 960px) -->
            <div class="visitor-stats d-none d-md-inline-flex">
              <v-icon small color="grey darken-1" class="mr-1">mdi-eye-outline</v-icon>
              <span v-if="loading" class="grey--text text--darken-1">
                {{ $t('footer.loading') }}
              </span>
              <span v-else-if="error" class="grey--text text--darken-1">
                {{ $t('footer.visitors') }}
              </span>
              <span v-else class="grey--text text--darken-2">
                <strong>{{ formatNumber(stats.totalUnique) }}</strong> {{ $t('footer.visitors') }}
              </span>
            </div>

            <!-- Divider - Hidden on mobile -->
            <span class="mx-2 grey--text text--lighten-1 d-none d-md-inline">•</span>

            <!-- Made with love - Desktop: full text, Mobile: without "for campers" -->
            <span class="grey--text text--darken-1">
              {{ $t('footer.madeWith') }}
              <v-icon small color="red" class="heart-icon">mdi-heart</v-icon>
              <span class="d-none d-sm-inline">{{ $t('footer.forCampers') }}</span>
            </span>

            <!-- Divider -->
            <span class="mx-2 grey--text text--lighten-1 d-none d-sm-inline">•</span>

            <!-- Analytics Link - Hidden on very small screens -->
            <a
              href="https://camping-calculator.goatcounter.com"
              target="_blank"
              rel="noopener noreferrer"
              class="analytics-link grey--text text--darken-1 d-none d-sm-inline"
            >
              <v-icon x-small class="mr-1">mdi-chart-line</v-icon>
              {{ $t('footer.analytics') }}
            </a>

            <!-- Divider - exactly one of the two shows: the analytics link and its
                 divider are hidden on xs, the legal links below never are -->
            <span class="mx-2 grey--text text--lighten-1 d-none d-sm-inline">•</span>
            <span class="mx-2 grey--text text--lighten-1 d-sm-none">•</span>

            <!-- Legal pages - must stay reachable on every screen size -->
            <a href="/impressum/" class="legal-link grey--text text--darken-1">
              {{ $t('footer.imprint') }}
            </a>

            <!-- Divider -->
            <span class="mx-2 grey--text text--lighten-1">•</span>

            <a href="/datenschutz/" class="legal-link grey--text text--darken-1">
              {{ $t('footer.privacy') }}
            </a>

            <!-- Divider -->
            <span class="mx-2 grey--text text--lighten-1">•</span>

            <!-- Share Buttons - Always visible! -->
            <ShareButtons />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import { getVisitorStats } from '@/utils/GoatCounterAPI.js'
import ShareButtons from '@/components/ShareButtons.vue'

export default {
  name: 'AppFooter',
  components: {
    ShareButtons
  },
  data() {
    return {
      stats: {
        total: 0,
        totalUnique: 0
      },
      loading: true,
      error: false
    }
  },
  mounted() {
    this.fetchStats()
    // Refresh stats every 5 minutes
    this.refreshInterval = setInterval(() => {
      this.fetchStats()
    }, 5 * 60 * 1000)
  },
  beforeDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },
  methods: {
    async fetchStats() {
      try {
        this.loading = true
        this.error = false
        const data = await getVisitorStats()

        if (data.error) {
          this.error = true
        } else {
          this.stats = data
        }
      } catch (err) {
        // Failed to fetch visitor stats
        this.error = true
      } finally {
        this.loading = false
      }
    },
    formatNumber(num) {
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M'
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'K'
      }
      return num.toLocaleString()
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/colors.less';

.app-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding: 12px 0;
}

.footer-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 14px;
  line-height: 1.5;
  gap: 4px;
}

.visitor-stats {
  display: inline-flex;
  align-items: center;
}

.heart-icon {
  animation: heartbeat 1.5s ease-in-out infinite;
  display: inline-block;
  margin: 0 2px;
}

@keyframes heartbeat {
  0%, 100% {
    transform: scale(1);
  }
  10%, 30% {
    transform: scale(1.1);
  }
  20%, 40% {
    transform: scale(1);
  }
}

.analytics-link,
.legal-link {
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #1976d2 !important;
    text-decoration: underline;
  }
}

// Mobile responsiveness
@media (max-width: 600px) {
  .app-footer {
    padding: 4px 0 !important;
  }

  .app-footer .v-footer__content {
    padding: 0 !important;
  }

  .app-footer .container {
    padding: 0 8px !important;
  }

  .app-footer .row {
    margin: 0 !important;
  }

  .app-footer .col {
    padding: 4px !important;
  }

  .footer-content {
    font-size: 12px;
    line-height: 1.3;
  }
}
</style>
